import { useEffect, useState } from 'react'
import { useParams, useLocation, Navigate } from 'react-router-dom'
import { pagesAPI } from '../../services/api'
import SafeHTML from '../../components/SafeHTML'

import { logger } from '@/utils/logger';
export default function DynamicPage() {
  const { slug: paramSlug } = useParams()
  const location = useLocation()

  // Extract slug from either params or pathname
  const slug = paramSlug || location.pathname.slice(1) // remove leading /

  const [page, setPage] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (slug) {
      loadPage()
    }
  }, [slug])

  const loadPage = async () => {
    try {
      setLoading(true)
      setError(null)
      const response = await pagesAPI.getBySlug(slug)
      setPage(response.data)
    } catch (err) {
      logger.error('Error loading page:', err)
      if (err.response?.status === 404) {
        setError('not_found')
      } else {
        setError('error')
      }
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '120px 0' }}>
        <span className="wc-spinner" role="status" aria-label="Lade Seite" />
      </div>
    )
  }

  if (error === 'not_found') {
    return <Navigate to="/" replace />
  }

  if (error || !page) {
    return (
      <div className="wc-container" style={{ padding: '96px 32px', textAlign: 'center' }}>
        <h1 style={{ marginBottom: 12 }}>Fehler</h1>
        <p className="wc-muted">Die Seite konnte nicht geladen werden.</p>
      </div>
    )
  }

  return (
    <div className="wc-container" style={{ padding: '72px 32px' }}>
      <article style={{ maxWidth: 800, margin: '0 auto' }}>
        <h1 style={{ marginBottom: 32 }}>{page.title}</h1>
        <div className="wc-hr" style={{ marginBottom: 32 }}></div>
        <SafeHTML html={page.content} className="prose max-w-none" />
      </article>
    </div>
  )
}
